import { useCallback } from 'react'
import { useTranslation } from '../components/IntlContext/IntlContext'

const DEFAULT_FALLBACK = 'generic.post'

function getErrorCandidates(error) {
	const data = error?.response?.data || {}
	const parameter = typeof data.parameter === 'string' ? data.parameter : null
	const message = typeof data.message === 'string' ? data.message : null

	return [parameter, message].filter(Boolean)
}

export function getApiErrorMessage(error, t, fallbackKey = DEFAULT_FALLBACK) {
	const candidates = getErrorCandidates(error)

	for (const key of candidates) {
		if (t?.errors?.[key]) return t.errors[key]
	}

	return t?.errors?.[fallbackKey]
}

export function useApiErrorMessage() {
	const t = useTranslation()

	return useCallback(
		(error, fallbackKey = DEFAULT_FALLBACK) => getApiErrorMessage(error, t, fallbackKey),
		[t]
	)
}
